<div class="profile-line">
    <div class="profile-name">{{ data.questionCategoryName }}</div>
    
    <div class="profile-value" [formGroup]="mainForm">
        <mat-form-field appearance="outline" class="w100 height-sm">
            <mat-label>Minimum</mat-label>
            <input matInput type="number" mask="0" min="1" max="8" formControlName="factorMin" autocomplete="off" (blur)="onBlur($event)">
        </mat-form-field>
        <mat-form-field appearance="outline" class="w100 height-sm">
            <mat-label>Maximum</mat-label>
            <input matInput type="number" mask="0" min="1" max="8" formControlName="factorMax" autocomplete="off" (blur)="onBlur($event)">
        </mat-form-field>
        <mat-checkbox *ngIf="isKeyFactorVisible" formControlName="isKeyFactor" (change)="onBlur($event)"></mat-checkbox>
    </div>
</div>
<app-form-validation-messages [form]="mainForm"></app-form-validation-messages>